import { Component, Input, OnInit } from '@angular/core';
import { CRMItem } from '../../models/crm/CRMItem.model';
import { CrmAlarmUtilsService } from '../../../core/data-services/crm-alarm-utils.service';
import { DateTimeService } from '../../../core/services';
import { DateTime } from 'luxon';

@Component({
    selector: 'rms-crm-archive-timer',
    templateUrl: './crm-archive-timer.component.html',
    styleUrls: ['./crm-archive-timer.component.scss'],
    standalone: false
})
export class CrmArchiveTimerComponent implements OnInit {

  @Input() crmItem: CRMItem = null;

  public alarmDate: DateTime = null;

  constructor(
    private crmAlarmUtilsService: CrmAlarmUtilsService,
  ) {}

  ngOnInit() {
    const alarm = this.crmAlarmUtilsService.findArchiveAlarm(this.crmItem);
    if (alarm) {
      this.alarmDate = DateTimeService.parseDate(alarm.trigger.value);
    }
  }

}
